

<h1 class="page-header">NordNative Social</h1>

<div class="social-links-container">
  <header class="social-links-header">
    <h1>Connect With Us</h1>
    <p>Explore our presence on social media and stay connected!</p>
  </header>

  <div class="social-links-grid">
    @for (platform of socialPlatforms; track platform) {
      <div class="social-card">
        <div class="icon-container" [style.background]="platform.color">
          <img [src]="platform.icon" alt="{{ platform.name }} icon" />
        </div>
        <div class="social-details">
          <h2>{{ platform.name }}</h2>
          <a [href]="platform.link" target="_blank" class="visit-link">Visit Us</a>
        </div>
      </div>
    }
  </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>